// Shared Cyber-Luxe tokens for marketplace pages (sky blue #1E9BD9 → warm gold #F5A962)
export const pageBg = (dark) => (dark ? 'bg-[#0A0B10]' : 'bg-[#F8FAFC]');

export const cardFrame = (dark) =>
  dark
    ? 'bg-[#181C2A]/85 backdrop-blur-xl border border-[#1E9BD9]/20 hover:border-[#1E9BD9]/55 hover:shadow-[0_16px_44px_rgba(30,155,217,0.2)]'
    : 'bg-white/95 backdrop-blur-xl border border-[#1E9BD9]/20 hover:border-[#1E9BD9]/60 shadow-sm hover:shadow-[0_16px_44px_rgba(30,155,217,0.14)]';

export const inputCls = (dark) =>
  dark
    ? 'bg-[#0A0B10]/70 border-[#1E9BD9]/20 text-white placeholder:text-slate-500 focus-visible:ring-[#1E9BD9]/40 focus-visible:border-[#1E9BD9]/60'
    : 'bg-white border-[#1E9BD9]/25 text-slate-800 placeholder:text-slate-400 focus-visible:ring-[#1E9BD9]/40 focus-visible:border-[#1E9BD9]/60';

export const selectCls = (dark) =>
  `h-11 rounded-xl px-3 border text-sm font-medium outline-none transition-colors focus:border-[#1E9BD9]/60 ${
    dark ? 'bg-[#0A0B10]/70 border-[#1E9BD9]/20 text-white' : 'bg-white border-[#1E9BD9]/25 text-slate-700'
  }`;

export const riseDelay = (index) => ({ animationDelay: `${Math.min(index, 11) * 55}ms` });

export const GOLD_BADGE =
  'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold text-white bg-gradient-to-r from-[#F5A962] to-[#F59E0B] shadow-[0_4px_12px_rgba(245,158,11,0.35)]';
